import React from "react";
import { AuthorizedContacts } from "../flexi/AuthorizedContacts.jsx";

export function ParentDetails({ guardianName, mobile, phone, email }) {

    return <div>
        <fieldset className="parent-details">
            <h3>Parent or Guardian Details</h3>
            <div className="input-group">
                <label>First and last name *</label>
                <input type="text" name="guardian_name" required defaultValue={guardianName} />
            </div>
            <div className="grouped-inputs-1">
                <div className="input-group">
                    <label>Primary Contact No. *</label>
                    <input type="tel" name="mobile" pattern="\d{11}" title="Enter a valid phone number (11 digits, no spaces)" required defaultValue={mobile} />
                </div>
                <div className="input-group">
                    <label>Second Contact No. *</label>
                    <input type="tel" name="phone" pattern="\d{11}" title="Enter a valid phone number (11 digits, no spaces)" required defaultValue={phone} />
                </div>
            </div>
            <div className="input-group">
                <label>Email address *</label>
                <input id="js-email" type="email" name="email" required defaultValue={email} />
            </div>
            {guardianName ? <a href="/parents" className="button-style edit">Edit My Account</a> : null}
        </fieldset>

        <AuthorizedContacts />
    </div>

}


// WEBPACK FOOTER //
// ./flexi/ParentDetails.jsx